import './base/';
import './utilities/is-touch';
import './utilities/responsive-images';
import './cart-drawer/cart';
import './sliders/slider';
import './product/ajax-actions';
import './product/quantity';
import './modules/nav-handler.js';
import './modules/accordion.js';
import './modules/js-aside-dropdown.js';
import './modules/tabs';
import './modules/modal';
import './modules/password-visible';
import './modules/triggerMasterSelect';
import './modules/handlePatterns';
import './modules/handleDropdown';
import './modules/closeDropdownOnClickOutside';
import './modules/handleDropdownMaterialOptions';
import './modules/handleDropdownPatternOptions';
import './modules/set-pattern-from-localstorage.js';
import './modules/set-cart-pattern.js';
import './modules/handle-nav-dropdown';
import './modules/scroll-to';

const $win = $(window);
const $doc = $(document);


// Your code goes here...
// jQuery.ready is no longer needed
